import createModel, { Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ParamsgroupsJoinsUsingGet,
  ParamsBodyarticlePublishUsingPut,
  CommonResultArticleVo,
  TeamVO,
  GroupVO
} from '@src/services';

export interface State {
  groupListModel: GroupVO[];
  teamListModel: TeamVO[];
}

export const releaseModelState: State = {
  groupListModel: [],
  teamListModel: []
};

const model = createModel({
  state: releaseModelState,
  namespace: 'releaseModel',
  reducers: {
    setGroupList: (state, action: Tction<{ groupListModel: GroupVO[] }>) => {
      return {
        ...state,
        groupListModel: action.payload.groupListModel
      };
    }
  },
  effects: {
    // 发布
    *artPublishAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsBodyarticlePublishUsingPut;
        callBack: (res: CommonResultArticleVo) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ArticleApi.articlePublishUsingPut> = yield tCall(
        APIS.ArticleApi.articlePublishUsingPut,
        action.payload.params
      );

      action.payload.callBack(res);
    },
    // 获取加入的圈子
    *getMyGroupsAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsgroupsJoinsUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsJoinsUsingGet> = yield tCall(
        APIS.GroupApi.groupsJoinsUsingGet,
        action.payload.params
      );
      const { result, code } = res;

      if (code === 0 && result) {
        yield tPut(model.actions.setGroupList, {
          groupListModel: result.list || []
        });
      }
    }
  }
});

/**
 * @description 全局Model releaseModel 挂载到 redux 上
 */
export default model;
